import { render } from "./UploadFile.vue?vue&type=template&id=c41a109e&scoped=true"
import script from "./UploadFile.js?vue&type=script&lang=js"
export * from "./UploadFile.js?vue&type=script&lang=js"

import "./UploadFile.vue?vue&type=style&index=0&id=c41a109e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c41a109e"]])

export default __exports__